/**
 * Configuração de conexão do tempo real.
 *
 * A URL sempre acompanha a origem da aplicação em produção — nunca `localhost`.
 * Em desenvolvimento, usa `REACT_APP_SOCKET_URL` ou a origem da API.
 */
export const SOCKET_PATH = '/socket.io';

const stripApiSuffix = (value) =>
  String(value || '')
    .replace(/\/api\/?$/, '')
    .replace(/\/$/, '');

export const getRealtimeUrl = () => {
  const explicit = process.env.REACT_APP_SOCKET_URL;
  if (explicit) return stripApiSuffix(explicit);

  if (process.env.NODE_ENV === 'production') {
    return window.location.origin;
  }

  const apiUrl = process.env.REACT_APP_API_URL;
  if (apiUrl) return stripApiSuffix(apiUrl);

  return 'http://localhost:5000';
};

/**
 * Token usado na autenticação do socket.
 * Usa apenas o token regular (admin continua admin mesmo com acesso mestre ativo).
 */
export const getAuthToken = () => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('token') || null;
};

export const AUTH_CHANGED_EVENT = 'realtime:auth-changed';

/** Evento legado disparado pela tela de login. */
export const LEGACY_AUTH_CHANGED_EVENT = 'auth-token-changed';

/** Notifica o provider para reconectar após login/logout. */
export const notifyAuthChanged = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
};

/**
 * Escuta mudanças de autenticação (outra aba, login, logout, master token).
 * @param {Function} handler
 * @returns {Function} cleanup
 */
export const onAuthTokenChange = (handler) => {
  if (typeof window === 'undefined') return () => {};

  const onStorage = (event) => {
    if (!event || ['token', 'isAdmin', 'userId'].includes(event.key)) handler();
  };

  window.addEventListener('storage', onStorage);
  window.addEventListener(AUTH_CHANGED_EVENT, handler);
  window.addEventListener(LEGACY_AUTH_CHANGED_EVENT, handler);

  return () => {
    window.removeEventListener('storage', onStorage);
    window.removeEventListener(AUTH_CHANGED_EVENT, handler);
    window.removeEventListener(LEGACY_AUTH_CHANGED_EVENT, handler);
  };
};
